import { Component, Directive, Input } from '@angular/core'
import type { AbstractEditorComponent } from '../../edit/abstract-editor.component'

@Directive({
	selector: 'editorFrameTopRight',
	standalone: false,
})
export class EditorFrameTopRightDirective {}

@Component({
	selector: 'editor-frame',
	templateUrl: './editor-frame.component.html',
	styleUrls: ['./editor-frame.component.scss'],
	standalone: false,
})
export class EditorFrameComponent {
	@Input() editor: AbstractEditorComponent<any>
}
